import React, { useEffect, useState } from 'react'
import Spinner from "../Component/spinner/spinner";
import { Controller, useForm } from 'react-hook-form';
import { Autocomplete, Button, Checkbox, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { Country, State } from "country-state-city";
import { useLazyGetAllSIGGroupQuery } from '../app/services/SIGGroupServices';
import { useLazyGetAllChaptersQuery } from '../app/services/chapterServices';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { useCreateMemberReportMutation } from '../app/services/memberServices';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentScope } from '../app/auth/authSlice';
import { selectCurrentChapterAdmin } from '../app/features/chapterAdminSlice';
import { selectCurrentSig } from '../app/features/sigSlice';
import { TeachersExperience, PrimarilyTeachingForInstitution, LiteraryStudies, Linguistics, EnglishLanguageTeaching, InterdisciplinaryAreas, ProfessionalEngagement, PrimarilyTeachingForTeacher, TypeOfInstitution, TeachersQualification } from './../constant/constant'
import { toast } from 'react-toastify';
import { setMemberReportDetails } from '../app/features/memberReportSlice';
import ClearIcon from "@mui/icons-material/Clear";
import * as XLSX from "xlsx";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const includeOptions = ['New Membership', 'Renewed Membership', 'Expired Membership', 'Active Membership']
function MemberReportSuperAdmin() {
  const [loading, setLoading] = useState(false)
  const countries = Country.getAllCountries();
  const [allSIG, setAllSIG] = useState([])
  const [getAllSIG] = useLazyGetAllSIGGroupQuery();
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [getAllChapters] = useLazyGetAllChaptersQuery();
  const memberScope = useSelector(selectCurrentScope);
  const chapter = useSelector(selectCurrentChapterAdmin);
  const SIG = useSelector(selectCurrentSig)
  const [createMemberReport] = useCreateMemberReportMutation();
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [otherValues, setOtherValues] = useState({
    educationQualification: '',
    primarilyTaught: '',
    expertiseLiteraryStudies: '',
    linguistics: '',
    expertiseELT: '',
    interdisciplinaryAreas: ''
  })
  const { register, setValue, control, watch, reset, handleSubmit, formState: { errors }, setError, clearErrors } = useForm({
    defaultValues: {
      generate: '0',
      reportFor: memberScope === 'PORTAL_CHAPTER_ADMIN' ? 'A Chapter' : memberScope === 'PORTAL_SIG_ADMIN' ? 'A SIG' : '',
      chapterId: '',
      SIGGroupId: '',
      location: '',
      country: 'IN',
      state: '',
      // district: '',
      profileCriteria: '',
      include: '',
      // asOn: '',
      fromDate: '',
      toDate: '',
      selectPrimaryTeaching: '',
      selectedQualifications: [],
      YearsofExperience: '',
      selectNatureOfWork: [],
      expertiseLiteraryStudies: [],  // Replace with the actual value(
      expertiseLinguistics: [],
      expertiseELT: [],
      expertiseInterdisciplinaryAreas: []
    }, mode: 'onChange'
  })

  const states = watch('country')
    ? State.getStatesOfCountry(watch('country'))
    : [];

  const location = useLocation();
  const handleFormSubmit = async (formData) => {
    formData.country = (formData?.reportFor === 3 || formData?.reportFor === 3) ? countries.find(c => c.isoCode === formData.country).name : ''
    formData.selectedQualifications = formData?.selectedQualifications?.map(q => q === "Other" ? otherValues?.educationQualification : q);
    if (formData?.selectPrimaryTeaching === 99) {
      formData.selectPrimaryTeaching = 'Other'
      formData.otherPrimaryTeaching = otherValues?.primarilyTaught
    }
    else {
      const selectPrimaryTeaching = formData.selectPrimaryTeaching
      formData.selectPrimaryTeaching = selectPrimaryTeaching
      delete formData.otherPrimaryTeaching;
    }
    formData.expertiseLiteraryStudies = formData?.expertiseLiteraryStudies?.map(q => q === "Other" ? otherValues?.expertiseLiteraryStudies : q);
    formData.expertiseLinguistics = formData?.expertiseLinguistics?.map(q => q === "Other" ? otherValues?.linguistics : q);
    formData.expertiseELT = formData?.expertiseELT?.map(q => q === "Other" ? otherValues?.expertiseELT : q);
    formData.expertiseInterdisciplinaryAreas = formData?.expertiseInterdisciplinaryAreas?.map(q => q === "Other" ? otherValues?.interdisciplinaryAreas : q);
    formData.expertise = {
      expertiseLiteraryStudies: formData?.expertiseLiteraryStudies || [],
      expertiseLinguistics: formData?.expertiseLinguistics || [],
      expertiseELT: formData?.expertiseELT || [],
      expertiseInterdisciplinaryAreas: formData?.expertiseInterdisciplinaryAreas || []
    }
    formData.engagementValues = formData.engagementValues ? formData.engagementValues.map(v => v.label) : []
    delete formData.expertiseLiteraryStudies;
    delete formData.expertiseLinguistics;
    delete formData.expertiseELT;
    delete formData.expertiseInterdisciplinaryAreas;
    try {
      setLoading(true)
      const res = await createMemberReport(formData)
      if (res?.data?.status) {
        // toast.success(res?.data?.message)
        dispatch(setMemberReportDetails(res?.data?.data));
        if (formData.generate === 0 || formData.generate === '0') {
          const pathPrefix = location.pathname.includes('/chapterAdmin') ? '/chapterAdmin' : location.pathname.includes('/sigAdmin') ? '/sigAdmin' : '/admin';
          navigate(`${pathPrefix}/member-report-preview?include=${formData?.include.map((t, i) => t.split(' ').join('_'))}&from=${formData?.fromDate}&to=${formData?.toDate}`)
        }
        else {
          exportToExcel(res?.data?.data, formData.include)
        }
        setLoading(false);
      }
      else {
        setLoading(false);
        toast.error(res?.data?.err?.message)
      }
    }
    catch (err) {
      setLoading(false);
      toast.error('Failed to generate report:' + err)
    }

  }
  useEffect(() => {
    getAllSIG().then((res) => {
      setAllSIG(res?.data?.data || []);
      if (memberScope === 'PORTAL_SIG_ADMIN') {
        setValue('SIGGroupId', SIG._id)
      }
    });
    getAllChapters().then((res) => {
      setSelectedChapters(res?.data?.data || []);
      if (memberScope === 'PORTAL_CHAPTER_ADMIN') {
        setValue('chapterId', chapter._id)
      }
    });

  }, [getAllSIG, getAllChapters, chapter, SIG, memberScope, setValue])

  const exportToExcel = (memberdata, selectedIncludes = []) => {
    const rows = [];

    // Map form include option labels to status keys used in data
    const includeStatusMap = {
      'New Membership': { status: 'New', key: 'newMembers' },
      'Renewed Membership': { status: 'Renewal', key: 'renewalMembers' },
      'Expired Membership': { status: 'Expired', key: 'expiredMembers' },
      'Active Membership': { status: 'Active', key: 'activeMembers' },
    };

    // Determine which statuses to include; if none selected, include all
    const activeIncludes = selectedIncludes && selectedIncludes.length > 0
      ? selectedIncludes
      : Object.keys(includeStatusMap);

    memberdata.membershipSummary.forEach((type) => {
      type.planTypes.forEach((plan) => {

        const statuses = activeIncludes
          .filter((opt) => includeStatusMap[opt])
          .map((opt) => ({
            status: includeStatusMap[opt].status,
            members: plan[includeStatusMap[opt].key] || [],
          }));

        statuses.forEach(({ status, members }) => {
          if (members.length > 0) {
            members.forEach((member) => {
              rows.push({
                "Member ID": member.userId,
                "Name": member.fullName || member.institution,
                "Email": member.email,
                "Mobile": member.mobileNumber,
                "City": member.city,
                "State": member.state,
                "Country": member.country,
                "Membership Type": type.membershipType,
                "Membership Plan": plan.membershipPlan,
                "Status": status,
                "Start Date": member.plans?.[0]?.planStartDate
                  ? new Date(member.plans[0].planStartDate).toLocaleDateString()
                  : "",
                "End Date": member.plans?.[0]?.planEndDate
                  ? new Date(member.plans[0].planEndDate).toLocaleDateString()
                  : "",
                ...(memberScope === "PORTAL_SUPER_ADMIN" && {
                  "Payment Type":
                    member.plans?.[0]?.paymentType === 0
                      ? "Cash"
                      : member.plans?.[0]?.paymentType === 1
                        ? "Online"
                        : member.plans?.[0]?.paymentType === 2
                          ? "Cheque"
                          : "N/A",
                  "Payment Method":
                    member.plans?.[0]?.paymentMethod || "N/A",
                  "Transaction ID":
                    member.plans?.[0]?.bankTransactionId || "N/A",
                  "Payment Date":
                    member.plans?.[0]?.paymentDate
                      ? new Date(
                        member.plans[0].paymentDate
                      ).toLocaleDateString()
                      : "N/A",
                  "Amount":
                    member.plans?.[0]?.amount ??
                    member.plans?.[0]?.dummyAmount ??
                    "N/A",
                }),
              });
            });
          }
        });
      });
    });

    if (rows.length > 0) {
      toast.success("Report generated successfully!");
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Members");
      XLSX.writeFile(workbook, "Members.xlsx");
    } else {
      toast.error("No data found");
    }
  };


  return (
    <>
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">Generate Membership Reports</h2>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <form onSubmit={handleSubmit(handleFormSubmit)} className="p-md-5 p-3 overallPadding">
          <div className="text-end mb-3">
            <Button
              onClick={() => window.history.back()}
              variant="contained"
              className="menus-color">
              Back
            </Button>
          </div>
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item xs={12} md={6} lg={4} className="d-flex justify-content-between">
              <Controller className='w-100' rules={{ required: "Please select a option" }} control={control} name="generate" render={({ field, fieldState }) => (
                <FormControl className="w-100">
                  <InputLabel id='state-label'>
                    <span className="text-dark">Generate</span>
                    <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    id="State"
                    labelId="state-label"
                    fullWidth
                    label={<span className="text-black">Generate <span className="text-danger">*</span></span>}
                    value={field?.value ?? ""}
                    onChange={(e) => {
                      field.onChange(e.target.value)
                      clearErrors();
                      reset(
                        {
                          generate: watch('generate'),
                          reportFor: memberScope === 'PORTAL_CHAPTER_ADMIN' ? 1 : memberScope === 'PORTAL_SIG_ADMIN' ? 2 : '',
                          chapterId: '',
                          SIGGroupId: '',
                          location: '',
                          country: 'IN',
                          state: '',
                          profileCriteria: '',
                          include: '',
                          // asOn: '',
                          fromDate: '',
                          toDate: '',
                          selectPrimaryTeaching: '',
                          selectedQualifications: [],
                          YearsofExperience: '',
                          selectNatureOfWork: [],
                          expertiseLiteraryStudies: [],  // Replace with the actual value(
                          expertiseLinguistics: [],
                          expertiseELT: [],
                          expertiseInterdisciplinaryAreas: []
                        }
                      )
                    }}
                    error={!!fieldState.error}
                  >
                    <MenuItem value={0}>
                      Membership Status Report
                    </MenuItem>
                    <MenuItem value={1}>
                      List of Members
                    </MenuItem>
                  </Select>
                  <FormHelperText className="text-danger">
                    {fieldState?.error?.message}
                  </FormHelperText>
                </FormControl>
              )} />
            </Grid>
            {memberScope === 'PORTAL_SUPER_ADMIN' && <Grid item xs={12} md={6} lg={4} className="d-flex justify-content-between">
              <Controller className='w-100' rules={{ required: "Please select report for" }} control={control} name="reportFor" render={({ field, fieldState }) => (
                <FormControl className="w-100">
                  <InputLabel id='state-label'>
                    {watch('generate') === (1 || '1') ? <span className="text-dark">List for</span> : <span className="text-dark">Report for</span>}
                    <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    id="reportFor"
                    labelId="reportFor-label"
                    fullWidth
                    label={<span className="text-black">Report for <span className="text-danger">*</span></span>}
                    value={field?.value ?? ""}
                    onChange={(e) => {
                      field.onChange(e.target.value)
                      setValue('chapterId', '');
                      setValue('SIGGroupId', '');
                      setValue('country', 'IN');
                      clearErrors(['SIGGroupId', 'chapterId', 'country', 'state']);
                      setValue('state', '');
                    }}
                    error={!!fieldState.error}
                  >
                    <MenuItem value={0}>
                      The Association
                    </MenuItem>
                    <MenuItem value={1}>
                      A Chapter
                    </MenuItem>
                    <MenuItem value={2}>
                      A SIG
                    </MenuItem>
                    <MenuItem value={3}>
                      A Location
                    </MenuItem>
                  </Select>
                  <FormHelperText className="text-danger">
                    {fieldState?.error?.message}
                  </FormHelperText>
                </FormControl>
              )} />
            </Grid>}
            {watch('reportFor') === (3 || '3') && <>

              <Grid item lg={4} md={6} xs={12}>
                <FormControl
                  fullWidth
                  className="mt-0"
                  error={!!errors.country}
                >
                  <InputLabel className="text-dark">
                    Country <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    name="country"
                    control={control}
                    defaultValue="IN"
                    rules={{
                      required: "Please select a country", // Validation rule
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        className="bg-white"
                        label={
                          <Typography className="text-dark">
                            Country <span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        value={field.value || 'IN'}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          setValue("state", "");
                        }}
                        disabled
                      >
                        <MenuItem value="">
                          <em>Select Country</em>
                        </MenuItem>
                        {countries.map((country) => (
                          <MenuItem
                            key={country.isoCode}
                            value={country.isoCode}
                          >
                            {country.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  {errors.country && (
                    <FormHelperText>
                      {errors.country.message}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item lg={4} md={6} xs={12}>
                <FormControl
                  fullWidth
                  disabled={!watch("country")}
                  error={!!errors.state}
                >
                  <InputLabel className="text-dark">
                    State<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    name="state"
                    control={control}
                    rules={{
                      required: watch("country") && "Please select a state", // Only required if a country is selected
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        label={
                          <Typography className="text-dark">
                            State <span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        readOnly={!watch('country')}
                        value={field.value || ''}
                        onChange={(e) => {
                          field.onChange(e);
                        }}
                      >
                        <MenuItem value="">
                          <em>Select State</em>
                        </MenuItem>
                        {states.map((state) => (
                          <MenuItem key={state.isoCode} value={state.name}>
                            {state.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  {errors.state && (
                    <FormHelperText>{errors.state.message}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              {/* <Grid item xs={12} md={6} lg={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  helperText={errors?.district?.message}
                  fullWidth
                  error={!!errors?.district}
                  id="district"
                  placeholder="Enter chapter district"
                  label={
                    <Typography className="text-dark">
                      District <span style={{ color: "red" }}>*</span>
                    </Typography>
                  }
                  variant="outlined"
                  {...register("district", { required: "Please enter a district" })}
                />
              </Grid> */}
            </>
            }
            {memberScope === "PORTAL_SUPER_ADMIN" && watch('reportFor') === (1 || '1') && <Grid item lg={4} md={6} sm={6} xs={12} >
              <Controller
                control={control}
                name={'chapterId'}
                rules={{ required: 'Please select a chapter' }}
                render={({ field, fieldState }) => (
                  <>
                    <Autocomplete
                      id="tags-outlined-chapter"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      options={selectedChapters}
                      getOptionLabel={(option) =>
                        option?.title || ""
                      }
                      isOptionEqualToValue={(option, value) => option._id === value._id}
                      filterSelectedOptions
                      onChange={(event, value) => {
                        // Check if value is not null before accessing _id
                        field.onChange(value ? value._id : "");
                      }}
                      value={
                        field.value
                          ? selectedChapters.find((group) => group._id === field.value) || null
                          : null
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="memberId"
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                          label={
                            <Typography className="text-dark">
                              Name of the Chapter{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Typography>
                          }
                          placeholder="Select Chapter"
                        />
                      )}
                    />
                  </>
                )}
              />
            </Grid>}
            {memberScope === "PORTAL_SUPER_ADMIN" && watch('reportFor') === (2 || '2') && <Grid item lg={4} md={6} sm={6} xs={12} >
              <Controller
                control={control}
                name={'SIGGroupId'}
                rules={{ required: 'Please select a SIG group' }}
                render={({ field, fieldState }) => (
                  <>
                    <Autocomplete
                      id="tags-outlined-chapter"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      options={allSIG}
                      getOptionLabel={(option) =>
                        option?.groupName || ""
                      }
                      isOptionEqualToValue={(option, value) => option._id === value._id}
                      filterSelectedOptions
                      onChange={(event, value) => {
                        field.onChange(value ? value._id : "");// Pass the selected _id to onChange
                      }}
                      value={
                        field.value
                          ? allSIG.find((group) => group._id === field.value) || null
                          : null
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="memberId"
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                          label={
                            <Typography className="text-dark">
                              Name of the SIG{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Typography>
                          }
                          placeholder="Select SIG"
                        />
                      )}
                    />
                  </>
                )}
              />
            </Grid>}


            {watch('generate') === (1 || '1') && <Grid item xs={12} md={6} lg={4} className="d-flex justify-content-between">
              <Controller className='w-100' control={control} name="profileCriteria" render={({ field, fieldState }) => (
                <FormControl className="w-100">
                  <InputLabel id='state-label' shrink>
                    <span className="text-dark">Member Profile Criteria</span>
                  </InputLabel>
                  <Select
                    id="reportFor"
                    labelId="reportFor-label"
                    fullWidth
                    label={<span className="text-black">Member Profile Criteria <span className="text-danger">*</span></span>}
                    value={field?.value || ""}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      clearErrors(['YearsofExperience', 'expertiseELT', 'expertiseInterdisciplinaryAreas', 'expertiseLinguistics', 'expertiseLiteraryStudies', 'selectNatureOfWork', 'selectPrimaryTeaching', 'selectedQualifications'])
                    }}
                    endAdornment={
                      field?.value ? (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => {
                              field.onChange("");
                              clearErrors([
                                'YearsofExperience',
                                'expertiseELT',
                                'expertiseInterdisciplinaryAreas',
                                'expertiseLinguistics',
                                'expertiseLiteraryStudies',
                                'selectNatureOfWork',
                                'selectPrimaryTeaching',
                                'selectedQualifications'
                              ]);
                            }}
                          >
                            <ClearIcon className='mx-2' fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ) : null
                    }

                    error={!!fieldState.error}
                    displayEmpty
                  >
                    <MenuItem value={''}>
                      All
                    </MenuItem>
                    <MenuItem value={0 || '0'}>
                      Educational Qualification
                    </MenuItem>
                    <MenuItem value={1 || '1'}>
                      Teaching Experience
                    </MenuItem>
                    <MenuItem value={2 || '2'}>
                      Level at which you are primarily teaching/taught (Teacher)
                    </MenuItem>
                    <MenuItem value={7 || '7'}>
                      Level at which you are primarily teaching/taught (Institution)
                    </MenuItem>
                    <MenuItem value={3 || '3'}>
                      Nature of Work
                    </MenuItem>
                    <MenuItem value={4 || '4'}>
                      Ph.D. Supervisor
                    </MenuItem>
                    <MenuItem value={5 || '5'}>
                      Area of Expertise
                    </MenuItem>
                    <MenuItem value={6 || "6"}>
                      Interested in
                    </MenuItem>
                  </Select>
                  <FormHelperText className="text-danger">
                    {fieldState?.error?.message}
                  </FormHelperText>
                </FormControl>
              )} />
            </Grid>}

            {(watch('profileCriteria') === 0 || watch('profileCriteria') === '0') && (
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <Controller
                  control={control}
                  name="selectedQualifications"
                  rules={{
                    required: 'Please select a qualification option',
                    validate: () => {
                      const selected = watch('selectedQualifications');
                      if (selected.includes('Other') && !otherValues.educationQualification.trim()) {
                        return 'Please specify other qualification';
                      }
                      return true;
                    }
                  }}
                  render={({ field, fieldState }) => {
                    let selectedValues = field.value ?? [];
                    const hasOther = selectedValues.includes('Other');
                    return (
                      <>
                        <Autocomplete
                          multiple
                          fullWidth
                          id="checkboxes-tags-demo"
                          className="bg-white"
                          limitTags={1}
                          value={selectedValues}
                          options={TeachersQualification.map((q) => q.name)}
                          onChange={(event, value) => {
                            let updated = value.filter((v) => TeachersQualification.some((q) => q.name === v) || v === 'Other');
                            field.onChange([...new Set(updated)]);
                            // If "Other" is removed, clear the input
                            if (!updated.includes('Other')) {
                              setOtherValues({ ...otherValues, educationQualification: "" });
                              clearErrors('selectedQualifications');
                            }
                          }}
                          disableCloseOnSelect
                          isOptionEqualToValue={(option, value) => option === value}
                          renderOption={(props, option, { selected }) => (
                            <li key={option} {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              error={!!fieldState.error}
                              helperText={fieldState?.error?.message}
                              label={
                                <Typography className="text-dark">
                                  Selected Qualifications <span className="text-danger">*</span>
                                </Typography>
                              }
                              placeholder={watch('selectedQualifications')?.length ? '' : 'Select qualifications'}
                            />
                          )}
                        />

                        {hasOther && (
                          <TextField
                            fullWidth
                            margin="normal"
                            placeholder="Please specify"
                            value={otherValues.educationQualification}
                            onChange={(e) => {
                              const val = e.target.value.trim();
                              setOtherValues({ ...otherValues, educationQualification: val });
                              if (!val) {
                                setError('selectedQualifications', {
                                  type: 'manual',
                                  message: 'Please specify other qualification',
                                });
                              }
                              else {
                                clearErrors('selectedQualifications'); // Optional
                              }
                            }}
                            onBlur={(e) => {
                              const val = e.target.value.trim();
                              if (!val) {
                                setError('selectedQualifications', {
                                  type: 'manual',
                                  message: 'Please specify other qualification',
                                });
                              } else {
                                clearErrors('selectedQualifications');
                              }
                            }}
                            error={!!fieldState.error}
                            helperText={fieldState?.error?.message}
                          />
                        )}
                      </>
                    );
                  }}
                />
              </Grid>
            )}

            {(watch('profileCriteria') === 1 || watch('profileCriteria') === '1') && (
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <Controller className='w-100' rules={{ required: "Please select Teaching Experience" }} control={control} name="YearsofExperience" render={({ field, fieldState }) => (
                  <FormControl className="w-100">
                    <InputLabel id='state-label'>
                      <span className="text-dark">Teaching Experience</span>
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      id="State"
                      labelId="state-label"
                      fullWidth
                      label={<span className="text-black">Teaching Experience <span className="text-danger">*</span></span>}
                      value={field?.value ?? ""}
                      onChange={(e) => {
                        field.onChange(e.target.value)
                      }}
                      error={!!fieldState.error}
                    >
                      {
                        TeachersExperience.map((data, i) => (
                          <MenuItem value={data.name}>
                            {data.name}
                          </MenuItem>
                        ))
                      }
                    </Select>
                    <FormHelperText className="text-danger">
                      {fieldState?.error?.message}
                    </FormHelperText>
                  </FormControl>
                )} />
              </Grid>
            )}
            {((watch('profileCriteria') === 2 || watch('profileCriteria') === '2') || watch('profileCriteria') === 7 || watch('profileCriteria') === '7') && (
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <Controller className='w-100' rules={{
                  required: "Please select Select Primary Teaching",
                  validate: () => {
                    const selected = watch('selectPrimaryTeaching');
                    // ✅ This will only trigger on submit or manual trigger
                    if (!selected) {
                      return 'Please select a qualification option';
                    }
                    if (selected === 99 && !otherValues.primarilyTaught.trim()) {
                      return 'Please specify other qualification';
                    }
                    return true;
                  }
                }} control={control} name="selectPrimaryTeaching" render={({ field, fieldState }) => (
                  <FormControl className="w-100">
                    <InputLabel id='state-label'>
                      <span className="text-dark">Level at which you are primarily teaching/taught</span>
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      id="State"
                      labelId="state-label"
                      fullWidth
                      label={<span className="text-black">Level at which you are primarily teaching/taught <span className="text-danger">*</span></span>}
                      value={field?.value ?? ""}
                      onChange={(e) => {
                        field.onChange(e.target.value)
                        if (e.target.value !== 99) {
                          setOtherValues({ ...otherValues, primarilyTaught: '' });
                        }
                      }}
                      error={!!fieldState.error}
                    >
                      {
                        watch('profileCriteria') === 7 || watch('type') === '7' ? PrimarilyTeachingForInstitution.map((data, i) => (
                          <MenuItem value={data.id}>
                            {data.label}
                          </MenuItem>
                        )) :
                          PrimarilyTeachingForTeacher.map((data, i) => (
                            <MenuItem value={data.id}>
                              {data.label}
                            </MenuItem>
                          ))
                      }
                    </Select>
                    <FormHelperText className="text-danger">
                      {fieldState?.error?.message}
                    </FormHelperText>
                    {field.value === 99 && (
                      <TextField
                        fullWidth
                        margin="normal"
                        placeholder="Please specify"
                        value={otherValues.primarilyTaught}
                        onChange={(e) => {
                          const val = e.target.value;
                          setOtherValues({ ...otherValues, primarilyTaught: val });

                          // ✅ Don't show error here
                          if (fieldState.invalid) {
                            clearErrors('selectPrimaryTeaching'); // Optional
                          }
                        }}
                        onBlur={(e) => {
                          const val = e.target.value.trim();
                          if (!val) {
                            setError('selectPrimaryTeaching', {
                              type: 'manual',
                              message: 'Please specify other',
                            });
                          } else {
                            clearErrors('selectPrimaryTeaching');
                          }
                        }}
                        error={!!fieldState.error}
                        helperText={fieldState?.error?.message}
                      />
                    )}
                  </FormControl>
                )} />

              </Grid>
            )}
            {(watch('profileCriteria') === 3 || watch('profileCriteria') === '3') && (
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <Controller className='w-100' rules={{ required: "Please select Select Nature Of Work" }} control={control} name="selectNatureOfWork" render={({ field, fieldState }) => (
                  <FormControl className="w-100">
                    <InputLabel id='state-label'>
                      <span className="text-dark">Nature Of Work</span>
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      id="State"
                      labelId="state-label"
                      fullWidth
                      label={<span className="text-black">Nature Of Work <span className="text-danger">*</span></span>}
                      value={field?.value ?? ""}
                      onChange={(e) => {
                        field.onChange(e.target.value)
                      }}
                      error={!!fieldState.error}
                    >
                      {
                        TypeOfInstitution.map((data, i) => (
                          <MenuItem value={data.id}>
                            {data.type}
                          </MenuItem>
                        ))
                      }
                    </Select>
                    <FormHelperText className="text-danger">
                      {fieldState?.error?.message}
                    </FormHelperText>
                  </FormControl>
                )} />
              </Grid>
            )}
            {(watch('profileCriteria') === 5 || watch('profileCriteria') === '5') && (
              <>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <Controller
                    control={control}
                    name="expertiseLiteraryStudies"
                    rules={{
                      validate: () => {
                        const selected = watch('expertiseLiteraryStudies');
                        if (selected.includes('Other') && !otherValues.expertiseLiteraryStudies.trim()) {
                          return 'Please specify other expertise literary studies';
                        }
                        return true;
                      }
                    }}
                    render={({ field, fieldState }) => {
                      let selectedValues = field.value ?? [];
                      const hasOther = selectedValues.includes('Other');
                      return (
                        <>
                          <Autocomplete
                            multiple
                            fullWidth
                            id="checkboxes-tags-demo"
                            className="bg-white"
                            limitTags={1}
                            value={selectedValues}
                            options={LiteraryStudies.map((q) => q.name)}
                            onChange={(event, value) => {
                              let updated = value.filter((v) => LiteraryStudies.some((q) => q.name === v) || v === 'Other');
                              field.onChange([...new Set(updated)]);
                              // If "Other" is removed, clear the input
                              if (!updated.includes('Other')) {
                                setOtherValues({ ...otherValues, expertiseLiteraryStudies: "" });
                                clearErrors('expertiseLiteraryStudies');
                              }
                            }}
                            disableCloseOnSelect
                            isOptionEqualToValue={(option, value) =>
                              option === value || !LiteraryStudies.some((q) => q.name === value)
                            }
                            renderOption={(props, option, { selected }) => (
                              <li key={option} {...props}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                error={!!fieldState.error}
                                helperText={fieldState?.error?.message}
                                label={
                                  <Typography className="text-dark">
                                    Selected Expertise Literary Studies
                                  </Typography>
                                }
                                placeholder={watch('expertiseLiteraryStudies') ? '' : 'expertiseLiteraryStudies'}
                              />
                            )}
                          />

                          {/* ✅ Show text input when "Other" is selected */}
                          {hasOther && (
                            <TextField
                              fullWidth
                              margin="normal"
                              placeholder="Please specify"
                              value={otherValues?.expertiseLiteraryStudies}
                              onChange={(e) => {
                                const val = e.target.value.trim();
                                setOtherValues({ ...otherValues, expertiseLiteraryStudies: val });
                                if (!val) {
                                  setError('expertiseLiteraryStudies', {
                                    type: 'manual',
                                    message: 'Please specify other literary studies',
                                  });
                                }
                                else {
                                  clearErrors('expertiseLiteraryStudies'); // Optional
                                }
                              }}
                              onBlur={(e) => {
                                const val = e.target.value.trim();
                                if (!val) {
                                  setError('expertiseLiteraryStudies', {
                                    type: 'manual',
                                    message: 'Please specify other literary studies',
                                  });
                                } else {
                                  clearErrors('expertiseLiteraryStudies');
                                }
                              }}
                              error={!!fieldState.error}
                              helperText={fieldState?.error?.message}
                            />
                          )}

                        </>
                      );
                    }}
                  />

                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <Controller
                    control={control}
                    name="expertiseLinguistics"
                    rules={{
                      validate: () => {
                        const selected = watch('expertiseLinguistics');
                        if (selected.includes('Other') && !otherValues.linguistics.trim()) {
                          return 'Please specify other linguistics';
                        }
                        return true;
                      }
                    }}
                    render={({ field, fieldState }) => {
                      let selectedValues = field.value ?? [];
                      const hasOther = selectedValues.includes('Other');
                      return (
                        <>
                          <Autocomplete
                            multiple
                            fullWidth
                            id="checkboxes-tags-demo"
                            className="bg-white"
                            limitTags={1}
                            value={selectedValues}
                            options={Linguistics.map((q) => q.name)}
                            onChange={(event, value) => {
                              let updated = value.filter((v) => Linguistics.some((q) => q.name === v) || v === 'Other');
                              field.onChange([...new Set(updated)]);
                              // If "Other" is removed, clear the input
                              if (!updated.includes('Other')) {
                                setOtherValues({ ...otherValues, linguistics: "" });
                                clearErrors('expertiseLinguistics');
                              }
                            }}
                            disableCloseOnSelect
                            isOptionEqualToValue={(option, value) =>
                              option === value || !Linguistics.some((q) => q.name === value)
                            }
                            renderOption={(props, option, { selected }) => (
                              <li key={option} {...props}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                error={!!fieldState.error}
                                helperText={fieldState?.error?.message}
                                label={
                                  <Typography className="text-dark">
                                    Selected Linguistics
                                  </Typography>
                                }
                                placeholder={watch('expertiseLinguistics') ? '' : 'expertiseLinguistics'}
                              />
                            )}
                          />

                          {/* ✅ Show text input when "Other" is selected */}
                          {hasOther && (
                            <TextField
                              fullWidth
                              margin="normal"
                              placeholder="Please specify"
                              value={otherValues?.linguistics}
                              onChange={(e) => {
                                const val = e.target.value.trim();
                                setOtherValues({ ...otherValues, linguistics: val });
                                if (!val) {
                                  setError('expertiseLinguistics', {
                                    type: 'manual',
                                    message: 'Please specify other linguistics',
                                  });
                                }
                                else {
                                  clearErrors('expertiseLinguistics'); // Optional
                                }
                              }}
                              onBlur={(e) => {
                                const val = e.target.value.trim();
                                if (!val) {
                                  setError('expertiseLinguistics', {
                                    type: 'manual',
                                    message: 'Please specify other linguistics',
                                  });
                                } else {
                                  clearErrors('expertiseLinguistics');
                                }
                              }}
                              error={!!fieldState.error}
                              helperText={fieldState?.error?.message}
                            />
                          )}

                        </>
                      );
                    }}
                  />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <Controller
                    control={control}
                    name="expertiseELT"
                    rules={{
                      validate: () => {
                        const selected = watch('expertiseELT');
                        if (selected.includes('Other') && !otherValues.expertiseELT.trim()) {
                          return 'Please specify other ELT';
                        }
                        return true;
                      }
                    }}
                    render={({ field, fieldState }) => {
                      let selectedValues = field.value ?? [];
                      const hasOther = selectedValues.includes('Other');
                      return (
                        <>
                          <Autocomplete
                            multiple
                            fullWidth
                            id="checkboxes-tags-demo"
                            className="bg-white"
                            limitTags={1}
                            value={selectedValues}
                            options={EnglishLanguageTeaching.map((q) => q.name)}
                            onChange={(event, value) => {
                              let updated = value.filter((v) => EnglishLanguageTeaching.some((q) => q.name === v) || v === 'Other');
                              field.onChange([...new Set(updated)]);
                              // If "Other" is removed, clear the input
                              if (!updated.includes('Other')) {
                                setOtherValues({ ...otherValues, expertiseELT: "" });
                                clearErrors('expertiseELT');
                              }
                            }}
                            disableCloseOnSelect
                            isOptionEqualToValue={(option, value) =>
                              option === value || !EnglishLanguageTeaching.some((q) => q.name === value)
                            }
                            renderOption={(props, option, { selected }) => (
                              <li key={option} {...props}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                error={!!fieldState.error}
                                helperText={fieldState?.error?.message}
                                label={
                                  <Typography className="text-dark">
                                    Selected Expertise ELT
                                  </Typography>
                                }
                                placeholder={watch('expertiseELT') ? '' : 'expertiseELT'}
                              />
                            )}
                          />

                          {/* ✅ Show text input when "Other" is selected */}
                          {hasOther && (
                            <TextField
                              fullWidth
                              margin="normal"
                              placeholder="Please specify"
                              value={otherValues?.expertiseELT}
                              onChange={(e) => {
                                const val = e.target.value.trim();
                                setOtherValues({ ...otherValues, expertiseELT: val });
                                if (!val) {
                                  setError('expertiseELT', {
                                    type: 'manual',
                                    message: 'Please specify other ELT',
                                  });
                                }
                                else {
                                  clearErrors('expertiseELT'); // Optional
                                }
                              }}
                              onBlur={(e) => {
                                const val = e.target.value.trim();
                                if (!val) {
                                  setError('expertiseELT', {
                                    type: 'manual',
                                    message: 'Please specify other ELT',
                                  });
                                } else {
                                  clearErrors('expertiseELT');
                                }
                              }}
                              error={!!fieldState.error}
                              helperText={fieldState?.error?.message}
                            />
                          )}

                        </>
                      );
                    }}
                  />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <Controller
                    control={control}
                    name="expertiseInterdisciplinaryAreas"
                    rules={{
                      validate: () => {
                        const selected = watch('expertiseInterdisciplinaryAreas');
                        if (selected.includes('Other') && !otherValues.interdisciplinaryAreas.trim()) {
                          return 'Please specify other';
                        }
                        return true;
                      }
                    }}
                    render={({ field, fieldState }) => {
                      let selectedValues = field.value ?? [];
                      const hasOther = selectedValues.includes('Other');
                      return (
                        <>
                          <Autocomplete
                            multiple
                            fullWidth
                            id="checkboxes-tags-demo"
                            className="bg-white"
                            limitTags={1}
                            value={selectedValues}
                            options={InterdisciplinaryAreas.map((q) => q.name)}
                            onChange={(event, value) => {
                              let updated = value.filter((v) => InterdisciplinaryAreas.some((q) => q.name === v) || v === 'Other');
                              field.onChange([...new Set(updated)]);
                              // If "Other" is removed, clear the input
                              if (!updated.includes('Other')) {
                                setOtherValues({ ...otherValues, interdisciplinaryAreas: "" });
                                clearErrors('expertiseInterdisciplinaryAreas');
                              }
                            }}
                            disableCloseOnSelect
                            isOptionEqualToValue={(option, value) =>
                              option === value || !InterdisciplinaryAreas.some((q) => q.name === value)
                            }
                            renderOption={(props, option, { selected }) => (
                              <li key={option} {...props}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                error={!!fieldState.error}
                                helperText={fieldState?.error?.message}
                                label={
                                  <Typography className="text-dark">
                                    Selected Interdisciplinary Areas
                                  </Typography>
                                }
                                placeholder={watch('expertiseInterdisciplinaryAreas') ? '' : 'InterdisciplinaryAreas'}
                              />
                            )}
                          />

                          {/* ✅ Show text input when "Other" is selected */}
                          {hasOther && (
                            <TextField
                              fullWidth
                              margin="normal"
                              placeholder="Please specify"
                              value={otherValues?.interdisciplinaryAreas}
                              onChange={(e) => {
                                const val = e.target.value.trim();
                                setOtherValues({ ...otherValues, interdisciplinaryAreas: val });
                                if (!val) {
                                  setError('expertiseInterdisciplinaryAreas', {
                                    type: 'manual',
                                    message: 'Please specify other',
                                  });
                                }
                                else {
                                  clearErrors('expertiseInterdisciplinaryAreas'); // Optional
                                }
                              }}
                              onBlur={(e) => {
                                const val = e.target.value.trim();
                                if (!val) {
                                  setError('expertiseInterdisciplinaryAreas', {
                                    type: 'manual',
                                    message: 'Please specify other',
                                  });
                                } else {
                                  clearErrors('expertiseInterdisciplinaryAreas');
                                }
                              }}
                              error={!!fieldState.error}
                              helperText={fieldState?.error?.message}
                            />
                          )}

                        </>
                      );
                    }}
                  />
                </Grid>
              </>
            )}
            {(watch('profileCriteria') === 6 || watch('profileCriteria') === '6') && (
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <Controller
                  control={control}
                  name="engagementValues"
                  rules={{ required: "Please select an option" }}
                  render={({ field, fieldState }) => (
                    <>
                      <Autocomplete
                        multiple
                        fullWidth
                        id="checkboxes-tags-demo"
                        className="bg-white"
                        limitTags={1}
                        value={field.value || []} // Correct value usage
                        options={ProfessionalEngagement}
                        onChange={(event, value) => field.onChange(value)} // Pass selected objects
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) => option.id === value.id} // Compare by id
                        getOptionLabel={(option) => option.label} // Display label
                        renderOption={(props, option, { selected }) => {
                          const { key, ...optionProps } = props;
                          return (
                            <li key={option.id} {...optionProps}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.label}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            fullWidth
                            error={!!fieldState.error}
                            helperText={fieldState?.error?.message}
                            {...params}
                            label={
                              <Typography className="text-dark">
                                Engagement Values <span className="text-danger">*</span>
                              </Typography>
                            }
                            placeholder={watch("engagementValues") ? "" : "engagementValues"}
                          />
                        )}
                      />
                    </>
                  )}
                />
              </Grid>

            )}
            <Grid item lg={4} md={6} sm={6} xs={12} >
              <Controller
                control={control}
                name='include'
                rules={{ required: 'Please select a include option' }}
                render={({ field, fieldState }) => (
                  <>
                    <Autocomplete
                      multiple
                      fullWidth
                      id="checkboxes-tags-demo"
                      className='bg-white'
                      limitTags={1}
                      value={field.value || []}
                      options={includeOptions}
                      onChange={(event, value) => {
                        field.onChange(value ? value : '');// Pass the selected _id to onChange
                      }}
                      disableCloseOnSelect
                      isOptionEqualToValue={(option, value) => option === value}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField fullWidth error={!!fieldState.error} helperText={fieldState?.error?.message} {...params} label={<Typography className='text-dark'>Include <span className='text-danger'>*</span></Typography>} placeholder={watch('include') ? "" : "Includes"} />
                      )}
                    />                  </>
                )}
              />
            </Grid>

            {/* {watch('generate') === (1 || '1') && <Grid item lg={4} md={6} xs={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="establishedOn"
                label={
                  <Typography className="text-dark">
                    As On <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
                {...register("asOn", {
                  required: "Please select a date", validate: (value) => {
                    const year = new Date(value).getFullYear().toString();
                    if (year.length > 4) {
                      return "Year cannot exceed 4 digits";
                    }
                    return true;
                  }, max: { value: new Date().toISOString().split("T")[0], message: 'Please select past or present date' }
                })}
                error={!!errors?.asOn}
                helperText={errors?.asOn?.message}
              />
            </Grid>} */}
            <Grid item lg={4} md={6} xs={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="from"
                label={
                  <Typography className="text-dark">
                    From <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
                {...register("fromDate", {
                  required: "Please select a from date",
                  onChange: () => {
                    setValue('toDate')
                  },
                  validate: (value) => {
                    const year = new Date(value).getFullYear().toString();
                    if (year.length > 4) {
                      return "Year cannot exceed 4 digits";
                    }
                    return true;
                  },
                })}
                error={!!errors?.fromDate}
                helperText={errors?.fromDate?.message}
              />
            </Grid>
            <Grid item lg={4} md={6} xs={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="to"
                label={
                  <Typography className="text-dark">
                    To <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                  min: watch('fromDate'),
                }}
                {...register("toDate", {
                  required: "Please select a to date",
                  validate: (value) => {
                    const year = new Date(value).getFullYear().toString();
                    if (year.length > 4) {
                      return "Year cannot exceed 4 digits";
                    }
                    return true;
                  },
                  min: {
                    value: watch('fromDate'),
                    message: "To date cannot be earlier than From date",
                  },
                  max: {
                    value: new Date().toISOString().split("T")[0],
                    message: "To date cannot be greater than current date",
                  }
                })}
                error={!!errors?.toDate}
                helperText={errors?.toDate?.message}
              />
            </Grid>


            <Grid item xs={12} lg={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button variant="contained" className="menus-color" type="submit">
                  {watch('generate') === 0 ? 'Submit' : ' Generate Excel List'}
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      )
      }
    </>
  )
}

export default MemberReportSuperAdmin